import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { ICustodyDTOIn, ICustodyDTOOut, ICustodyItem } from '../interfaces/garde.interface';
import { parseDate } from '../utils/date.utils';

@Injectable({
    providedIn: 'root',
})
export class GardesService {
    constructor(private http: HttpClient) {}

    public updateCustodies(c: ICustodyDTOOut, studentId: number, custodyId: number): Observable<ICustodyDTOIn> {
        return this.http
            .put<ICustodyDTOIn>(environment.wasoApi + 'students/' + studentId + '/student_custodies/' + custodyId, c)
            .pipe(map((result: any) => result));
    }

    public getCustodies(studentId: number): Observable<ICustodyDTOIn> {
        return this.http.get<ICustodyDTOIn>(environment.wasoApi + 'students/' + studentId + '/student_custodies').pipe(
            map((c: ICustodyDTOIn) => {
                const ciArray: ICustodyItem[] = [];
                (c.custody_items || []).forEach((ci: any) => {
                    ciArray.push({
                        ...ci,
                        date: parseDate(ci.date),
                    });
                });
                return {
                    ...c,
                    custody_items: ciArray,
                };
            })
        );
    }
}
